export default __webpack_public_path__ + "static/media/logo-sm.87ff5472.svg";